import Vue from 'vue'
import ImagePreview from '@/components/common/ImagePreview.vue'

let instance = null

function createInstance() {
  const PreviewConstructor = Vue.extend(ImagePreview)
  instance = new PreviewConstructor()
  instance.$mount(document.createElement('div'))
  document.body.appendChild(instance.$el)
  return instance
}

function getInstance() {
  if (!instance) {
    createInstance()
  }
  return instance
}

export function openImagePreview(options) {
  return getInstance().open(options)
}

export default {
  install(Vue) {
    Vue.prototype.$imagePreview = function (urlOrOptions) {
      return openImagePreview(urlOrOptions)
    }
  }
}
